// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tag[data-v-e56703b4]{padding:2px 5px;box-sizing:border-box;border-radius:3px}.tag.is-success.is-light[data-v-e56703b4]{background-color:#fff;border:1px solid #48c774;color:#48c774}.tag.is-danger.is-light[data-v-e56703b4]{background-color:#fff;color:#f14668;border:1px solid #f14668}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
